var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.74512,9.4458A.92829.92829,0,0,0,50,9.07129H30a.92837.92837,0,0,0-.88086.63525l-10,30A.92844.92844,0,0,0,20,40.92871H34.86719L29.08936,69.81787a.92855.92855,0,0,0,1.65234.74072l30-39.81689a.92858.92858,0,0,0-.731-1.48731l-14.76709-.16894,5.646-18.81836A.92974.92974,0,0,0,50.74512,9.4458ZM43.11035,29.73291a.92908.92908,0,0,0,.87891,1.1958l14.16406.16211L31.70947,66.188l5.20117-26.00586A.92851.92851,0,0,0,36,39.07129H21.28857l9.38086-28.14258H48.752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon_energy.4d070299bfc4f269562cce3e504b2551.svg";
export { ForwardRef as ReactComponent };